/* eslint-disable graphql/template-strings */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
import { adStatus } from 'config';
// our components
import RouterContext from 'helpers/routerContext';
import AuthContext from 'helpers/authContext';
import { bulkUpdate } from 'helpers/updateMutationsHelper';
import { Query, Mutation } from 'components/common/Query';
import {
  REVIEW_ADS_MUTATION,
  UNREVIEW_ADS_MUTATION,
  PUBLISH_ADS_MUTATION,
  UNPUBLISH_ADS_MUTATION,
  REPROCESS_ADS_MUTATION,
} from 'components/Ad/List';
import { USER_INFO_FRAGMENT } from 'components/User/Info';
import AdsRead from './Details';

export const sharedAdFields = `
      id
      userId
      title
      price
      currency
      description
      subcategory {
        id
        title
        parentCategory {
          id
          title
        }
      }
      province {
        name
      }
      municipality {
        name
      }
      name
      email
      firstPhone
      firstPhonePrefix
      firstPhoneType
      secondPhone
      secondPhonePrefix
      secondPhoneType
      whatsapp
      contactInfo
      images {
        id
        lastStatus
        status
        urls {
          thumb
          high
        }
      }
      updatedOn
      updatedOnByUser
      updatedOnToOrder
      permalink
      status
      reviewed
      matchedRules
      isAuto
      isPromoted
      ipInsert
      ipUpdate
      botScoreInsert
      botScoreUpdate
      botScoreInsertErrors
      botScoreUpdateErrors
      countryInsert
      countryUpdate
      updateCount
      viewCount
      reviewedBy {
        id
        fullname
      }
      reviewedOn
      autoPaidad {
        id
      }
      offensive: flag(flagType: PROHIBIDO_OFENSIVO) {
        lastFlaggedOn
        total
      }
      spam: flag(flagType: REPETIDO_SPAM) {
        lastFlaggedOn
        total
      }
      classified: flag(flagType: MAL_CATEGORIZADO) {
        lastFlaggedOn
        total
      }
      scam: flag(flagType: ESTAFA) {
        lastFlaggedOn
        total
      }
      joke: flag(flagType: FALSO_BROMA) {
        lastFlaggedOn
        total
      }
      notes {
        id
        createdOn
        description
        creator
      }
`;

/**
 * Query to fetch an Ad from api
 */
export const AD_QUERY = gql`
  query Ad($id: Int!) {
    ad(id: $id) {
      ${sharedAdFields}
      user {
        ...fragmentUserInfo
      }
    }
  }
  ${USER_INFO_FRAGMENT}
`;

/**
 * Mocked logs data
 */
const mockData = {
  logs: [
    {
      // First story
      badgeColor: 'danger',
      title: 'Some Title',
      titleColor: 'danger',
      body: (
        <p>
          Wifey made the best Fathers Day meal ever. So thankful so happy so
          blessed. Thank you for making my family We just had fun with the
          “future” theme !!! It was a fun night all together ... The always rude
          Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in
          downtown.
        </p>
      ),
      footerTitle: '11 hours ago via Twitter',
    },
    {
      // Second story
      badgeColor: 'success',
      title: 'Another One',
      titleColor: 'success',
      body: (
        <p>
          Thank God for the support of my wife and real friends. I also wanted
          to point out that it’s the first album to go number 1 off of
          streaming!!! I love you Ellen and also my number one design rule of
          anything I do from shoes to music to homes is that Kim has to like
          it....
        </p>
      ),
    },
    {
      // Fourth story
      badgeColor: 'warning',
      title: 'Another One',
      titleColor: 'warning',
      body: (
        <p>
          Tune into Big Boys 92.3 Im about to play the first single from Cruel
          Winter also to Kim’s hair and makeup Lorraine jewelry and the whole
          style squad at Balmain and the Yeezy team. Thank you Anna for the
          invite thank you to the whole Vogue team
        </p>
      ),
    },
  ],
};

/**
 * @class
 * @extends Component
 */
class AdDetailsContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.Compose = adopt({
      mutateAdPublish: this.adPublish,
      mutateAdUnPublish: this.adUnPublish,
      mutateAdReview: this.adReview,
      mutateAdReprocess: this.adReprocess,
      mutateAdUnReview: this.adUnReview,
      query: this.ad,
    });
    this.fetchMore = () => {};
  }

  /**
   * @description
   * User's query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  ad = ({ render }) => {
    const { id } = this.props;
    return (
      <Query
        query={AD_QUERY}
        variables={{ id }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMore = fetchMore;
          return render({ data, loading, fetchMore });
        }}
      </Query>
    );
  };

  /**
   * @description
   * Mutation delete callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adReview = ({ render }) => (
    <AuthContext.Consumer>
      {({ id, fullname }) => (
        <Mutation
          mutation={REVIEW_ADS_MUTATION}
          update={(cache, { data: { reviewAd } }) => {
            const data = {
              reviewed: true,
              reviewedBy: { id, fullname, __typename: 'UserType' },
              reviewedOn: Date.now(),
              __typename: 'AdminAdType',
            };

            const field = `${'reviewed ' +
              'reviewedBy {id fullname} ' +
              'reviewedOn '}`;

            bulkUpdate(
              cache,
              'AdminAdType',
              'Review',
              field,
              data,
              reviewAd.successIds,
            );
          }}
        >
          {handleAdReview => render({ handleAdReview })}
        </Mutation>
      )}
    </AuthContext.Consumer>
  );

  /**
   * @description
   * Mutation unreview callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnReview = ({ render }) => (
    <AuthContext.Consumer>
      {() => (
        <Mutation
          mutation={UNREVIEW_ADS_MUTATION}
          update={(cache, { data: { unReviewAd } }) => {
            const data = {
              reviewed: false,
              reviewedBy: null,
              reviewedOn: null,
              __typename: 'AdminAdType',
            };

            const field = `${'reviewed ' +
              'reviewedBy {id fullname}' +
              'reviewedOn '}`;

            bulkUpdate(
              cache,
              'AdminAdType',
              'Unreview',
              field,
              data,
              unReviewAd.successIds,
            );
          }}
        >
          {(handleAdUnReview, { loading }) =>
            render({ handleAdUnReview, loadingAdUnReview: loading })
          }
        </Mutation>
      )}
    </AuthContext.Consumer>
  );

  /**
   * @description
   * Mutation delete callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublish = ({ render }) => (
    <Mutation
      mutation={PUBLISH_ADS_MUTATION}
      update={(cache, { data: { publishAd } }) => {
        const data = {
          status: adStatus.PUBLISHED_BY_MODERATOR,
          __typename: 'AdminAdType',
        };

        bulkUpdate(
          cache,
          'AdminAdType',
          'Publish',
          'status',
          data,
          publishAd.successIds,
        );
      }}
    >
      {(handleAdPublish, { loading }) =>
        render({ handleAdPublish, loadingAdPublish: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation delete callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnPublish = ({ render }) => (
    <Mutation
      mutation={UNPUBLISH_ADS_MUTATION}
      update={(cache, { data: { unPublishAd } }) => {
        const data = {
          status: adStatus.UNPUBLISHED_BY_MODERATOR,
          __typename: 'AdminAdType',
        };

        bulkUpdate(
          cache,
          'AdminAdType',
          'Unpublish',
          'status',
          data,
          unPublishAd.successIds,
        );
      }}
    >
      {(handleAdUnPublish, { loading }) =>
        render({ handleAdUnPublish, loadingAdUnPublish: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation reprocess callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adReprocess = ({ render }) => (
    <Mutation
      mutation={REPROCESS_ADS_MUTATION}
      update={(cache, { data: { reprocessAd } }) => {
        const data = {
          status: adStatus.PENDING_PROCESSING,
          __typename: 'AdminAdType',
        };

        bulkUpdate(
          cache,
          'AdminAdType',
          'Reprocess',
          'status',
          data,
          reprocessAd.successIds,
        );
      }}
    >
      {(handleAdReprocess, { loading }) =>
        render({ handleAdReprocess, loadingAdReprocess: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Refresh the list.
   * @returns {Function} - Fetch More function.
   */
  handleRefresh = () => {
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Render AdDetails component.
   * @returns {*} AdsRead component.
   */
  render() {
    return (
      <this.Compose>
        {({
          mutateAdReview: { handleAdReview, loadingAdReview },
          mutateAdUnReview: { handleAdUnReview, loadingAdUnReview },
          mutateAdPublish: { handleAdPublish, loadingAdPublish },
          mutateAdUnPublish: { handleAdUnPublish, loadingAdUnPublish },
          mutateAdReprocess: { handleAdReprocess, loadingAdReprocess },
          query: { data, loading },
        }) => {
          if (!loading) {
            return (
              <AdsRead
                data={{ ...data, ...mockData }}
                adReview={items =>
                  handleAdReview({ variables: { ids: items } })
                }
                adUnReview={items =>
                  handleAdUnReview({ variables: { ids: items } })
                }
                adPublish={items =>
                  handleAdPublish({ variables: { ids: items } })
                }
                adUnPublish={items =>
                  handleAdUnPublish({ variables: { ids: items } })
                }
                adReprocess={items =>
                  handleAdReprocess({ variables: { ids: items } })
                }
                adActionLoading={
                  loadingAdReview ||
                  loadingAdPublish ||
                  loadingAdUnPublish ||
                  loadingAdReprocess ||
                  loadingAdUnReview
                }
                refresh={this.handleRefresh}
              />
            );
          }
          return (
            <ContentLoader
              height={871}
              width={1073}
              speed={2}
              primaryColor="#d9d9d9"
              secondaryColor="#ecebeb"
            >
              <path
                // eslint-disable-next-line max-len
                d="M8,61 L292,61 C296.418278,61 300,64.581722 300,69 L300,71 C300,75.418278 296.418278,79 292,79 L8,79 C3.581722,79 5.41083001e-16,75.418278 0,71 L0,69 C-5.41083001e-16,64.581722 3.581722,61 8,61 Z M486,61 L554,61 C558.418278,61 562,64.581722 562,69 L562,71 C562,75.418278 558.418278,79 554,79 L486,79 C481.581722,79 478,75.418278 478,71 L478,69 C478,64.581722 481.581722,61 486,61 Z M590,61 L700,61 C704.418278,61 708,64.581722 708,69 L708,71 C708,75.418278 704.418278,79 700,79 L590,79 C585.581722,79 582,75.418278 582,71 L582,69 C582,64.581722 585.581722,61 590,61 Z M764,61 L1065,61 C1069.41828,61 1073,64.581722 1073,69 L1073,121 C1073,125.418278 1069.41828,129 1065,129 L764,129 C759.581722,129 756,125.418278 756,121 L756,69 C756,64.581722 759.581722,61 764,61 Z M764,153 L1065,153 C1069.41828,153 1073,156.581722 1073,161 L1073,661 C1073,665.418278 1069.41828,669 1065,669 L764,669 C759.581722,669 756,665.418278 756,661 L756,161 C756,156.581722 759.581722,153 764,153 Z M764,685 L1065,685 C1069.41828,685 1073,688.581722 1073,693 L1073,863 C1073,867.418278 1069.41828,871 1065,871 L764,871 C759.581722,871 756,867.418278 756,863 L756,693 C756,688.581722 759.581722,685 764,685 Z M8,111 L700,111 C704.418278,111 708,114.581722 708,119 L708,121 C708,125.418278 704.418278,129 700,129 L8,129 C3.581722,129 5.41083001e-16,125.418278 0,121 L0,119 C-5.41083001e-16,114.581722 3.581722,111 8,111 Z M8,137 L397,137 C401.418278,137 405,140.581722 405,145 L405,147 C405,151.418278 401.418278,155 397,155 L8,155 C3.581722,155 5.41083001e-16,151.418278 0,147 L0,145 C-5.41083001e-16,140.581722 3.581722,137 8,137 Z M8,226 L700,226 C704.418278,226 708,229.581722 708,234 L708,598 C708,602.418278 704.418278,606 700,606 L8,606 C3.581722,606 5.41083001e-16,602.418278 0,598 L0,234 C-5.41083001e-16,229.581722 3.581722,226 8,226 Z M8,187 L129,187 C133.418278,187 137,190.581722 137,195 L137,197 C137,201.418278 133.418278,205 129,205 L8,205 C3.581722,205 5.41083001e-16,201.418278 0,197 L0,195 C-5.41083001e-16,190.581722 3.581722,187 8,187 Z M439,187 L700,187 C704.418278,187 708,190.581722 708,195 L708,197 C708,201.418278 704.418278,205 700,205 L439,205 C434.581722,205 431,201.418278 431,197 L431,195 C431,190.581722 434.581722,187 439,187 Z M19.5,0 L163.5,0 C174.269553,-1.97833472e-15 183,8.73044738 183,19.5 C183,30.2695526 174.269553,39 163.5,39 L19.5,39 C8.73044738,39 1.31888981e-15,30.2695526 0,19.5 C-1.31888981e-15,8.73044738 8.73044738,1.97833472e-15 19.5,0 Z M225.5,0 L345.5,0 C356.269553,-1.97833472e-15 365,8.73044738 365,19.5 C365,30.2695526 356.269553,39 345.5,39 L225.5,39 C214.730447,39 206,30.2695526 206,19.5 C206,8.73044738 214.730447,1.97833472e-15 225.5,0 Z"
                fill="#E5EAEC"
              />
            </ContentLoader>
          );
        }}
      </this.Compose>
    );
  }
}

/**
 * AdDetailsContainer PropTypes
 * @param id - prop to know id of the Ad
 */
AdDetailsContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default AdDetailsContainer;
